export const TAX_MAP: Record<string, any> = {
  GST: {
    en: 'GST',
    fr: 'TPS',
  },
  PST: {
    en: 'PST',
    fr: 'TVP',
  },
  HST: {
    en: 'HST',
    fr: 'TVH',
  },
  RST: {
    en: 'RST',
    fr: 'TVD',
  },
  QST: {
    en: 'QST',
    fr: 'TVQ',
  },
}
